import React, { useRef } from 'react';

// tools
import uniqid from '../../../../helpers/uniqid';

const ButtonIconQuickRadioAction = ({ children, onChange, checked }) => {
    const uuid = useRef(uniqid());
    const classes = ['appButton__iconQuickRadioAction']

    return(
        <label htmlFor={uuid.current} className={classes.join(' ')}>
            <input type="checkbox" id={uuid.current} onChange={onChange} checked={checked}/>
            {children}
        </label>
    )
}

export default ButtonIconQuickRadioAction;